module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "form",
      rawName: "v-form",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "detail-form"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "front-form-item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [(_vm.only_read) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$func.queryTaskTpl(_vm.detailData.template_id).tpl_name))]) : _c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.tempId),
      expression: "sub.tempId"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: (['任务类型']),
      expression: "['任务类型']"
    }],
    attrs: {
      "rule": "choose"
    },
    on: {
      "change": _vm.linkage
    },
    model: {
      value: (_vm.sub.tempId),
      callback: function($$v) {
        _vm.$set(_vm.sub, "tempId", $$v)
      },
      expression: "sub.tempId"
    }
  }, _vm._l((_vm.taskTpl_canChoose), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.tpl_name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), (_vm.only_read) ? _c('div', {
    staticClass: "front-form-item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.detailData.pub_bu_name))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "front-form-item"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [(_vm.only_read) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.detailData.sub_bu_name))]) : _c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.buId),
      expression: "sub.buId"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: (['指定BU']),
      expression: "['指定BU']"
    }],
    attrs: {
      "rule": "choose"
    },
    model: {
      value: (_vm.sub.buId),
      callback: function($$v) {
        _vm.$set(_vm.sub, "buId", $$v)
      },
      expression: "sub.buId"
    }
  }, _vm._l((_vm.bu_list), function(item) {
    return _c('z-limitOption', {
      key: item.id,
      attrs: {
        "label": item.bu_name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "front-form-item"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [(_vm.only_read) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.detailData.task_name))]) : _c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar.trim",
      value: (_vm.sub.taskName),
      expression: "sub.taskName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "maxlength": 30,
      "rule": "noVal"
    },
    model: {
      value: (_vm.sub.taskName),
      callback: function($$v) {
        _vm.$set(_vm.sub, "taskName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "sub.taskName"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "front-form-item"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [(_vm.only_read) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.detailData.task_description))]) : _c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.sub.taskDescribe),
      callback: function($$v) {
        _vm.$set(_vm.sub, "taskDescribe", $$v)
      },
      expression: "sub.taskDescribe"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "front-form-item"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "text type-text"
  }, [_vm._v(_vm._s(_vm.tpl_describe))])])]), _vm._v(" "), (_vm.task_id != 0) ? _c('div', {
    staticClass: "front-form-item"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.status_str))])])]) : _vm._e(), _vm._v(" "), (_vm.detailData.process_status == 103) ? _c('div', {
    staticClass: "front-form-item"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "text reduce"
  }, [_vm._v(_vm._s(_vm.detailData.fail_result))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "front-form-item"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [(_vm.only_read) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.detailData.task_cycle && _vm.detailData.task_cycle + "个工作日"))]) : _c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar.trim",
      value: (_vm.sub.taskCycle),
      expression: "sub.taskCycle",
      modifiers: {
        "trim": true
      }
    }, {
      name: "arg",
      rawName: "v-arg",
      value: ([_vm.time_range, '任务时长']),
      expression: "[time_range,'任务时长']"
    }],
    attrs: {
      "rule": "integer range"
    },
    model: {
      value: (_vm.sub.taskCycle),
      callback: function($$v) {
        _vm.$set(_vm.sub, "taskCycle", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "sub.taskCycle"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("工作日")])], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.time_range.length),
      expression: "time_range.length"
    }],
    staticClass: "tip"
  }, [_vm._v("范围：" + _vm._s(((_vm.time_range[0]) + "-" + (_vm.time_range[1]) + "工作日")))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "front-form-item"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [(_vm.only_read) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.detailData.currency_amount && _vm.detailData.currency_amount + "币"))]) : _c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar.trim",
      value: (_vm.sub.fastBonus),
      expression: "sub.fastBonus",
      modifiers: {
        "trim": true
      }
    }, {
      name: "arg",
      rawName: "v-arg",
      value: ([_vm.bonus_range, '任务奖金']),
      expression: "[bonus_range,'任务奖金']"
    }],
    attrs: {
      "rule": "integer range"
    },
    model: {
      value: (_vm.sub.fastBonus),
      callback: function($$v) {
        _vm.$set(_vm.sub, "fastBonus", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "sub.fastBonus"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.task_curr.currency_name))])], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bonus_range.length),
      expression: "bonus_range.length"
    }],
    staticClass: "tip"
  }, [_vm._v("范围：" + _vm._s(((_vm.bonus_range[0]) + "-" + (_vm.bonus_range[1]) + "币")))])])], 1)]), _vm._v(" "), (_vm.only_read) ? _c('div', {
    staticClass: "front-form-item"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.detailData.pub_user_name))])])]) : _vm._e(), _vm._v(" "), (_vm.only_read) ? _c('div', {
    staticClass: "front-form-item"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.detailData.sub_user_name || '暂无'))])])]) : _vm._e(), _vm._v(" "), (_vm.execute_judge) ? _c('div', {
    staticClass: "front-form-item",
    attrs: {
      "id": "executor"
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [(_vm.detailData.process_status == 201) ? _c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.person),
      expression: "sub.person"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: (['执行人']),
      expression: "['执行人']"
    }],
    ref: "select_dom",
    attrs: {
      "rule": "choose"
    },
    on: {
      "visible-change": _vm.hideChange
    },
    model: {
      value: (_vm.sub.person),
      callback: function($$v) {
        _vm.$set(_vm.sub, "person", $$v)
      },
      expression: "sub.person"
    }
  }, _vm._l((_vm.bu_users), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.real_name,
        "value": item.id
      }
    })
  })) : (_vm.assign_judge) ? _c('div', [_c('el-select', {
    model: {
      value: (_vm.assign_id),
      callback: function($$v) {
        _vm.assign_id = $$v
      },
      expression: "assign_id"
    }
  }, _vm._l((_vm.bu_users), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.real_name,
        "value": item.id
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "front-btn blue",
    class: {
      disabled: !_vm.assign_id || _vm.assign_id == (_vm.detailData.assign_user && _vm.detailData.assign_user.assign_to)
    },
    on: {
      "click": _vm.changeAssign
    }
  }, [_vm._v("变更")])], 1) : _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.detailData.assign_user && _vm.detailData.assign_user.real_name))])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.only_read) ? _c('div', {
    staticClass: "front-form-item"
  }, [_c('div', {
    staticClass: "item-title",
    class: {
      must: _vm.data.tpl_doc_require == 1
    }
  }, [_c('span', [_vm._v("文件上传：")])]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap doc-wrap"
  }, [_c('div', {
    staticClass: "front-btn"
  }, [_c('span', [_vm._v("选择文件")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        _vm.addUploadFile($event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "down-doctpl",
    on: {
      "click": function($event) {
        _vm.$emit('openDoc')
      }
    }
  }, [_vm._v("模板下载")]), _vm._v(" "), _c('z-scrollDiv', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.uploadDoc),
      expression: "sub.uploadDoc"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: ('上传文件'),
      expression: "'上传文件'"
    }],
    ref: "box",
    staticClass: "box",
    attrs: {
      "rule": _vm.upload_rule
    }
  }, [_vm._l((_vm.sub.uploadDoc), function(item, index) {
    return _c('div', {
      key: item.name,
      staticClass: "box-item"
    }, [_c('span', {
      staticClass: "overhide",
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "red",
      on: {
        "click": function($event) {
          _vm.sub.uploadDoc.splice(index, 1)
        }
      }
    }, [_vm._v("移除")])])
  }), _vm._v(" "), _vm._l((_vm.sub.require_doc), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "box-item"
    }, [_c('span', {
      staticClass: "overhide",
      attrs: {
        "title": item.doc_name
      }
    }, [_vm._v(_vm._s(item.doc_name))]), _vm._v(" "), _c('a', {
      staticClass: "blue",
      on: {
        "click": function($event) {
          _vm.downloadFile(item.id)
        }
      }
    }, [_vm._v("下载")]), _vm._v(" "), _c('span', {
      staticClass: "red",
      on: {
        "click": function($event) {
          _vm.addDeleteId(item.id, index)
        }
      }
    }, [_vm._v("移除")])])
  })], 2)], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title must"
  }, [_c('span', [_vm._v("任务类型：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title"
  }, [_c('span', [_vm._v("发布BU：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title must"
  }, [_c('span', [_vm._v("指定BU：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title must"
  }, [_c('span', [_vm._v("任务名称：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title"
  }, [_c('span', [_vm._v("任务描述：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title"
  }, [_c('span', [_vm._v("任务类型说明：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title"
  }, [_c('span', [_vm._v("任务状态：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title"
  }, [_c('span', [_vm._v("审核说明：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title must"
  }, [_c('span', [_vm._v("任务时长：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title must"
  }, [_c('span', [_vm._v("任务奖金：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title"
  }, [_c('span', [_vm._v("发布人：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title"
  }, [_c('span', [_vm._v("接收人：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title"
  }, [_c('span', [_vm._v("执行人：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-1ba094bc!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/task/detailTask/detail-form.vue
// module id = 703
// module chunks = 1